import styles from "./RightSidebar.module.css";
import { CartButton } from "../Buttons/CartButton/CartButton";
import { OpenBoosterButton } from "../Buttons/OpenBoosterButton/OpenBoosterButton";
import { PrintCardsButton } from "../Buttons/PrintCardsButton/PrintCardsButton";
import { OrdersButton } from "../Buttons/OrdersButton/OrdersButton";

const Sidebar: React.FC<{ scrolled: boolean }> = ({ scrolled }) => {
  return (
    <nav className={`${styles.sidebar} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.container}>
        <CartButton />
        <PrintCardsButton />
        <OpenBoosterButton />
        <OrdersButton />
      </div>
    </nav>
  );
};

export default Sidebar;
